export default __webpack_public_path__ + "static/media/brown_moon.3fcc87cd.png";